<template>
  <div>
    <div class="w-full mb-6">
      <label class="label" :for="label">
        {{ label }}
      </label>
    </div>

    <div class="flex flex-wrap mb-6">
      <div class="w-full md:w-1/2 pr-0 md:pr-4 mb-6 md:mb-0">
        <label class="label">
          Password
        </label>
        <input
          v-validate="{required: true, regex: '^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$' }"
          :name="field"
          :class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field) }"
          :id="field"
          placeholder="******************"
          type="password"
          v-model="fieldModel">
      </div>
      <div class="w-full md:w-1/2 pl-0 md:pl-4">
        <label class="label">
          Confirm Password
        </label>
        <input
          v-validate="validationRule"
          :name="secondPasswordField"
          placeholder="******************"
          :class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(secondPasswordField) }"
          :id="secondPasswordField"
          type="password"
          v-model="secondPassword">
      </div>
    </div>

    <div :class="{'mb-6': errors.has(field) }">
      <p class="text-red text-xs italic mt-3" v-show="errors.has(field)">Your password is weak, please enter at least 1 lower and upper case letter and 1 number with a minimum of 8 characters.</p>
    </div>

    <div :class="{'mb-6': errors.has(secondPasswordField) }">
      <p class="text-red text-xs italic mt-3" v-show="errors.has(secondPasswordField)">Please ensure your passwords match</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetPassword',
  inject: ['$validator'],
  props: {
    namespace: {
      type: String,
    },
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    validationMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      secondPassword: '',
    }
  },
  computed: {
    secondPasswordField: function() {
      return `${this.field}-2`
    },
    validationRule: function() {
      return `required|confirmed:${this.field}`;
    },
    fieldModel: {
      get() {
        return this.$store.state[this.namespace][this.field];
      },
      set(value) {
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/WidgetPassword.vue